import { trackingConfig } from "../config/tracking";

declare global {
  interface Window {
    clarity?: ((...args: any[]) => void) & { q?: any[] };
  }
}

let initialized = false;

const ensureScript = (id: string, src: string): void => {
  if (!src || typeof document === "undefined") return;
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

const ensureClarityBootstrap = (): void => {
  if (typeof window === "undefined") return;
  if (typeof window.clarity === "function") return;
  const clarityQueueFn = (...args: any[]) => {
    (clarityQueueFn.q = clarityQueueFn.q || []).push(args);
  };
  window.clarity = clarityQueueFn;
};

export const initTracking = (): void => {
  if (initialized) return;
  initialized = true;

  if (typeof window === "undefined" || typeof document === "undefined") return;

  if (trackingConfig.contentsquare.enabled && trackingConfig.contentsquare.src) {
    ensureScript("tracking-contentsquare", trackingConfig.contentsquare.src);
  }

  if (trackingConfig.clarity.enabled && trackingConfig.clarity.projectId) {
    ensureClarityBootstrap();
    ensureScript("tracking-clarity", `https://www.clarity.ms/tag/${trackingConfig.clarity.projectId}`);
  }
};

